import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';

import { loadDataAction } from '../store/actions/load-data.action';

import Navigation from './navigation/navigation.component';
import Home from './home/home.component';
import Expertise from './expertise/expertise.component';
import Skills from './skills/skills.component';
import References from './references/references.component';
import Jobs from './jobs/jobs.component';
import Education from './education/education.component';
import Contact from './contact/contact.component';

interface AppComponentProps {
  onLoadData: () => void;
}

class AppComponent extends Component<AppComponentProps, any> {

  componentDidMount() {
    this.props.onLoadData();
  }

  render() {
    return (
        <Container fluid={true} className="p-0">
          <Navigation/>
          <Home/>
          <Expertise/>
          <Skills/>
          <References/>
          <Jobs/>
          <Education/>
          <Contact/>
        </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onLoadData: () => dispatch(loadDataAction())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);



// WEBPACK FOOTER //
// ./src/components/app.component.tsx